import * as types from "./user.action.types";

export default {
  [types.GET_DoctorUsers]: (state, res) => {
    state.GET_DoctorUsers = res;
  },
};
